"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWorkflowCreativeWorkConfig = exports.Workflow_CreativeWorkConfigInputDec = exports.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_CHARACTERS = exports.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_STORYLINES_RELATIONSHIPS = exports.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_METADATA = exports.assertWorkflowCreativeWorkTagging = void 0;
const client_1 = require("@prisma/client");
const E = __importStar(require("fp-ts/lib/Either"));
const function_1 = require("fp-ts/lib/function");
const D = __importStar(require("io-ts/lib/Decoder"));
const codecs_1 = require("../../codecs");
function assertWorkflowCreativeWorkTagging(workflow) {
    if (!workflow || workflow.workflowType !== client_1.WorkflowType.CREATIVE_WORK_TAGGING) {
        throw new Error(`Workflow is not of type CREATIVE_WORK_TAGGING, given type was "${workflow.workflowType}."`);
    }
    const res = exports.Workflow_CreativeWorkConfigInputDec.decode(workflow.workflowConfig);
    if (E.isLeft(res)) {
        throw new Error(D.draw(res.left));
    }
}
exports.assertWorkflowCreativeWorkTagging = assertWorkflowCreativeWorkTagging;
exports.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_METADATA = 'metadata';
exports.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_STORYLINES_RELATIONSHIPS = 'storylines/relationships';
exports.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_CHARACTERS = 'characters';
exports.Workflow_CreativeWorkConfigInputDec = (0, function_1.pipe)(D.struct({
    task: D.literal(exports.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_METADATA, exports.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_STORYLINES_RELATIONSHIPS, exports.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_CHARACTERS),
    reviewRequired: (0, codecs_1.nullableW)(D.boolean),
}), D.withMessage(() => 'Workflow_CreativeWorkConfigInput'));
function buildWorkflowCreativeWorkConfig(base) {
    return {
        task: exports.WORKFLOW_CREATIVE_WORK_TAGGING_TASK_METADATA,
        reviewRequired: false,
        reviewPassed: false,
        assigneesTagger: [],
        assigneesReview: [],
        assigneesQA: [],
        ...base,
    };
}
exports.buildWorkflowCreativeWorkConfig = buildWorkflowCreativeWorkConfig;
//# sourceMappingURL=Workflow_CreativeWorkConfig.js.map